import { Errors } from 'components/Form/InputError'
import { Campaign } from 'types/campaign'

export type FormData = {
  asIds: string
  campaignStartDate: Campaign['startDate'] | null
  campaignEndDate: Campaign['endDate'] | null
}

export const formDataDefault: FormData = {
  asIds: '',
  campaignStartDate: null,
  campaignEndDate: null,
}

export interface FormDataErrors {
  asIds: Errors
}

export const formDataErrorsDefault: FormDataErrors = {
  asIds: [],
}
